var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHonestUniversity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 15,
    viewBox: "0 0 48 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4648 15H19.1705V0H13.4648V5.90726C12.4971 6.10887 11.2471 6.20968 10.1181 6.20968C7.51726 6.20968 6.06565 5.80645 6.06565 3.52823V0H0.339844V4.25403C0.339844 8.79032 3.22291 10.2016 8.72694 10.2016C10.8842 10.2016 12.3963 10 13.4648 9.79839V15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8628 11.5927L40.5241 0H34.6975L30.7056 6.5121L26.2903 0H19.6572L27.0362 10C27.2177 10.2419 27.2983 10.4234 27.2983 10.625V10.6452C27.2983 10.8468 27.1774 10.9879 26.7741 10.9879H24.133V15H27.137C30.4636 15 31.1491 14.1734 32.8628 11.5927Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3661 0L42.2008 10.1613H45.5476L47.4024 0H40.3661ZM46.7371 11.0685H41.0315V15H46.7371V11.0685Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHonestUniversity);
export default __webpack_public_path__ + "static/media/honestUniversity.50bb777b.svg";
export { ForwardRef as ReactComponent };